/**
 *
 * app sagas
 *
 */

import {
    all,
    put,
    takeLatest,
    select,
    call,
} from 'redux-saga/effects';
import { LOAD_APP } from './app-constants';
import { clientSideReady } from './app-actions';
import { makeSelectUserLocationEndpoint } from 'data/config/config-selectors';
import { setUserLocation } from 'data/config/config-actions';
import { setAdobeTarget } from 'data/config/runtime-config-actions';
import { makeSelectAdobeTargetConfig } from 'data/config/runtime-config-selectors';
import request from 'utils/request';

function getMboxes(adobeConfig) {
    return new Promise((resolve) => {
          adobe.target.getOffer({
            "mbox": "global-target-mbox",
            "success": function(offers) {
                resolve(offers)
            },    
            "error": function(status, error) {
            }
        });

    });

}

function hasActiveAdoebTargetTesting(cfg) {
    const mboxes = (cfg && cfg.request && cfg.request.prefetch && cfg.request.prefetch.mboxes) || [];
    
    return mboxes.filter((mbox) => {
       return mbox.enabled === true;
    }).length > 0;

}

export function* getAdobeTarget() {
    const adobeConfig = yield select(makeSelectAdobeTargetConfig());
    const hasEnabledAdobeTests = hasActiveAdoebTargetTesting(adobeConfig);

    let offers = {};
    
    if (hasEnabledAdobeTests && typeof adobe !== 'undefined') {
        offers = yield getMboxes(adobeConfig);
    }

    yield put(setAdobeTarget(offers));
}

export function* getUserLocation() {

    const requestURL = yield select(makeSelectUserLocationEndpoint());

    try {

        const data = yield call(request, requestURL);
        yield put(setUserLocation(data));

    } catch (error) {

        console.error(error);

    }

}

export function* bootstrapApp() {

    yield all([
        call(getUserLocation),
        call(getAdobeTarget)
    ]);
    
    yield put(clientSideReady());

}

/**
 * Root saga manages watcher lifecycle
 */
export default function* app() {

    // Watches for LOAD_APP action and calls getUserLocation when one comes in.
    // By using `takeLatest` only the result of the latest API call is applied.
    // It returns task descriptor (just like fork) so we can continue execution
    // It will be cancelled automatically on component unmount
    yield takeLatest(LOAD_APP, bootstrapApp);

}
